import { startOfMonth, endOfMonth, startOfWeek, endOfWeek, addDays, eachDayOfInterval, isSameMonth, isToday, format } from 'date-fns';

export const unitConversionMap = {
    gal: { metricUnit: "L", conversionRate: 3.78541 },
    oz: { metricUnit: "mL", conversionRate: 29.5735 },
    lbs: { metricUnit: "kg", conversionRate: 0.453592 },
    ft: { metricUnit: "m", conversionRate: 0.3048 },
    in: { metricUnit: "cm", conversionRate: 2.54 },
    yd: { metricUnit: "m", conversionRate: 0.9144 },
    mi: { metricUnit: "km", conversionRate: 1.60934 }
};

/**
 * Converts a value based on the unit and metric preference.
 * @param {number} value - The numerical value to convert.
 * @param {string} unit - The unit of measurement.
 * @param {boolean} metric - Whether to convert to metric.
 * @returns {object} - An object containing the converted value and unit.
 */
export const convertUnit = (value, unit, metric) => {
    if (!value || isNaN(value)) return { value: "0.00", unit };

    if (metric && unitConversionMap[unit]) {
        const { metricUnit, conversionRate } = unitConversionMap[unit];
        return { value: (value * conversionRate).toFixed(2), unit: metricUnit };
    }

    return { value: parseFloat(value).toFixed(2), unit };
};

export const UMMapping = {
    B12: { name: "BAG 12#", unit: "lbs", value: 12 },
    B25: { name: "BAG 25#", unit: "lbs", value: 25 },
    B30: { name: "BAG 30#", unit: "lbs", value: 30 },
    B40: { name: "BAG 40#", unit: "lbs", value: 40 },
    B5: { name: "BAG 5#", unit: "lbs", value: 5 },
    B50: { name: "BAG 50#", unit: "lbs", value: 50 },
    B51: { name: "BAG 51#", unit: "lbs", value: 51 },
    CS2: { name: "CASE (2x2.5)", unit: "gal", value: 5 },
    JUG: { name: "2.5 GAL JUG", unit: "gal", value: 2.5 },
    CS4: { name: "CASE (4X1)", unit: "gal", value: 4 },
    D30: { name: "DRUM 30-GAL", unit: "gal", value: 30 },
    D55: { name: "DRUM 55-GAL", unit: "gal", value: 55 },
    GAL: { name: "GALLON", unit: "gal", value: 1 },
    TR: { name: "TOTE REFILL", unit: "gal", value: 1 },
    LB: { name: "POUND", unit: "lbs", value: 1 },
    OZ: { name: "Ounce - Av", unit: "oz", value: 1 },
    PAI: { name: "PAIL 5-GAL", unit: "gal", value: 5 },
    SAC: { name: "Super Sack (B1000)", unit: "lbs", value: 1000 },
    SAC2: { name: "Super Sack (B2000)", unit: "lbs", value: 2000 },
    TON: { name: "TON (2,000#)", unit: "lbs", value: 2000 },
    T275: { name: "TOTE 275-GAL", unit: "gal", value: 275 },
};

// export const typeStyleMap = {
//     Liquid: 'bg-blue-400/15 border-blue-400',
//     Granular: 'bg-green-600/15 border-green-600',
//     Foliar: 'bg-yellow-500/15 border-yellow-500',
//     Soluable: 'bg-red-500/15 border-red-500'
// };
//
// export const textColorMap = {
//     Liquid: 'text-blue-400',
//     Granular: 'text-green-600',
//     Foliar: 'text-yellow-500',
//     Soluable: 'text-red-500',
// };
//
// export const typeBGColor = {
//     Liquid: 'bg-blue-400',
//     Granular: 'bg-green-600',
//     Foliar: 'bg-yellow-500',
//     Soluable: 'bg-red-500',
// };

export const typeStyleMap = {
    Liquid: 'bg-green-600/15 border-green-600',
    Granular: 'bg-green-600/15 border-green-600',
    Foliar: 'bg-green-600/15 border-green-600',
    Soluable: 'bg-green-600/15 border-green-600'
};

export const textColorMap = {
    Liquid: 'text-green-600',
    Granular: 'text-green-600',
    Foliar: 'text-green-600',
    Soluable: 'text-green-600',
};

export const typeBGColor = {
    Liquid: 'bg-green-600',
    Granular: 'bg-green-600',
    Foliar: 'bg-green-600',
    Soluable: 'bg-green-600',
};




// export function generateCalendarDays(year, month) {
//     // Create a reference date for the month (month is 0-indexed)
//     const currentDate = new Date(year, month, 1);
//
//     const start = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 0 }); // Monday
//     const end = endOfWeek(endOfMonth(currentDate), { weekStartsOn: 0 }); // Sunday
//
//     const days = eachDayOfInterval({ start, end });
//
//     return days.map(date => ({
//         date: format(date, 'yyyy-MM-dd'),
//         isCurrentMonth: isSameMonth(date, currentDate),
//         isToday: isToday(date),
//         events: [] // ready to be populated
//     }));
// }








// Helper to compute Easter Sunday using the Meeus/Jones/Butcher algorithm
function getEasterDate(year) {
    const f = Math.floor,
        G = year % 19,
        C = f(year / 100),
        H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
        I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
        J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
        L = I - J,
        month = 3 + f((L + 40) / 44),
        day = L + 28 - 31 * f(month / 4);
    return new Date(year, month - 1, day);
}

export function getUSHolidays(year) {
    const easter = getEasterDate(year);
    const goodFriday = new Date(easter);
    goodFriday.setDate(easter.getDate() - 2);

    const holidays = [
        // Federal and fixed holidays
        { name: "New Year's Day", date: new Date(year, 0, 1) },
        {
            name: "Martin Luther King Jr. Day",
            date: new Date(year, 0, 15 + ((1 - new Date(year, 0, 15).getDay() + 7) % 7)),
        },
        {
            name: "Presidents' Day",
            date: new Date(year, 1, 15 + ((1 - new Date(year, 1, 15).getDay() + 7) % 7)),
        },
        {
            name: "Memorial Day",
            date: new Date(year, 4, 31 - ((new Date(year, 4, 31).getDay() + 1) % 7)),
        },
        { name: "Juneteenth National Independence Day", date: new Date(year, 5, 19) },
        { name: "Independence Day", date: new Date(year, 6, 4) },
        {
            name: "Labor Day",
            date: new Date(year, 8, 1 + ((1 - new Date(year, 8, 1).getDay() + 7) % 7)),
        },
        {
            name: "Columbus Day",
            date: new Date(year, 9, 8 + ((1 - new Date(year, 9, 8).getDay() + 7) % 7)),
        },
        { name: "Veterans Day", date: new Date(year, 10, 11) },
        {
            name: "Thanksgiving Day",
            date: new Date(year, 10, 22 + ((4 - new Date(year, 10, 22).getDay() + 7) % 7)),
        },
        { name: "Christmas Eve", date: new Date(year, 11, 24) },
        { name: "Christmas Day", date: new Date(year, 11, 25) },

        // Religious/Cultural holidays
        { name: "Good Friday", date: goodFriday },
        { name: "Easter Sunday", date: easter },
        { name: "Valentine's Day", date: new Date(year, 1, 14) },
        { name: "St. Patrick's Day", date: new Date(year, 2, 17) },
        { name: "Halloween", date: new Date(year, 9, 31) },

        // Solstices and Equinoxes (approximate)
        { name: "Spring Equinox", date: new Date(year, 2, 20) },
        { name: "Summer Solstice", date: new Date(year, 5, 20) },
        { name: "Fall Equinox", date: new Date(year, 8, 22) },
        { name: "Winter Solstice", date: new Date(year, 11, 21) },

        // Golf Tournaments (approximate start days)
        { name: "The Masters Start", date: new Date(year, 3, 10) }, // 2nd Thurs in April
        { name: "The Masters Final", date: new Date(year, 3, 13) }, // Sunday
        { name: "PGA Championship Start", date: new Date(year, 4, 15) }, // Mid-May
        { name: "U.S. Open Start", date: new Date(year, 5, 13) }, // Mid-June
        { name: "The Open Championship Start", date: new Date(year, 6, 18) }, // Mid-July
        { name: "The Players Championship Start", date: new Date(year, 2, 14) }, // March
        { name: "The Memorial Tournament", date: new Date(year, 5, 3) }, // Early June
        { name: "FedEx Cup Final", date: new Date(year, 7, 25) }, // Late August
        { name: "Ryder Cup Start", date: new Date(year + (year % 2 === 0 ? 1 : 0), 8, 27) }, // Every other year in Sept
    ];

    return holidays.map(holiday => ({
        name: holiday.name,
        date: holiday.date,
        time: 'All Day',
        datetime: format(holiday.date, "yyyy-MM-dd'T'00:00"),
        href: '#',
    }));
}


export function generateCalendarDays(year, month, events = []) {
    const currentDate = new Date(year, month, 1);

    const start = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 0 });
    const end = endOfWeek(endOfMonth(currentDate), { weekStartsOn: 0 });

    const days = eachDayOfInterval({ start, end });

    // Create a map for faster lookup
    const eventMap = new Map();

    events.forEach(event => {
        const key = format(event.date, 'yyyy-MM-dd');
        if (!eventMap.has(key)) {
            eventMap.set(key, []);
        }
        eventMap.get(key).push(event);
    });

    return days.map(date => {
        const formatted = format(date, 'yyyy-MM-dd');
        return {
            date: formatted,
            isCurrentMonth: isSameMonth(date, currentDate),
            isToday: isToday(date),
            events: eventMap.get(formatted) || [],
        };
    });
}



// export function generateCalendarDays(year, month) {
//     const currentDate = new Date(year, month, 1);
//     const start = startOfWeek(startOfMonth(currentDate), { weekStartsOn: 0 }); // Sunday
//     const end = endOfWeek(endOfMonth(currentDate), { weekStartsOn: 0 }); // Saturday
//     const days = eachDayOfInterval({ start, end });
//
//     const holidayEvents = getUSHolidays(year);
//
//     return days.map(date => {
//         const dateString = format(date, 'yyyy-MM-dd');
//         const holidayForDate = holidayEvents.filter(event => event.date === dateString);
//
//         return {
//             date: dateString,
//             isCurrentMonth: isSameMonth(date, currentDate),
//             isToday: isToday(date),
//             events: holidayForDate,
//         };
//     });
// }


export const numberWithCommas = (number) => {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

// This Formats a phone number (---) --- - ----
export const formatPhoneNumber = (phoneNumber) => {
    // Remove any non-digit characters (just in case)
    const cleaned = ('' + phoneNumber).replace(/\D/g, '');

    // Check if the input is valid (10 digits)
    if (cleaned.length !== 10) {
        return phoneNumber; // Return the original input if invalid
    }

    // Format the phone number (XXX) XXX-XXXX
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }

    return phoneNumber; // Return the original input if not formatted
};


export const formatDate = (dateString) => {
    // Parse the date string into a Date object
    const [month, day, year] = dateString.split('/').map(Number);
    const date = new Date(year, month - 1, day);  // month is zero-based

    // Format the date as "Mar 29, 2025"
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return date.toLocaleDateString('en-US', options);
};
